<div *ngIf="data" class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="כפתור סגירה" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="benefits-plus" [ngClass]="{'no-popup': !data}" *ngIf="benefitResult">
    <div class="bread-crumbs" *ngIf="!isPopUp">
        <a title="" [href]="benefitsLink">הטבות | </a>
        <a title="" routerLink="/benefits/bizplus">הטבות פלוס | </a>
        <a title="" routerLink="/benefits/bizplus" [queryParams]="{type: benefitResult.type.typeUrlName}">{{benefitResult.type.typeName}} | </a>
        <span>{{benefitResult.name}}</span>
    </div>
    <div class="main-title">
        <h1>{{benefitResult.title}}</h1>
        <h2 *ngIf="benefitResult.discountPercent">{{benefitResult.discountPercent}}% הנחה במעמד החיוב </h2>
    </div>
    <div class="content">
        <div *ngIf="benefitResult.businessLogo && benefitResult.businessLogo.url" class="logo-wrapper">
            <img [src]="benefitResult.businessLogo.url" [alt]="benefitResult.businessLogo.alt" class="logo" />
        </div>
        <h3>קצת עלינו</h3>
        <p class="profile" *ngIf="description" [innerHtml]="description"></p>
        <div class="contact-us">
            <span class="adress" *ngIf="benefitResult.businessAddress">{{benefitResult.businessAddress}}</span>
            <a [href]="'tel:' + benefitResult.businessPhone" title="" class="link phone" *ngIf="isMobile && benefitResult.businessPhone" [rel]="'nofollow'">{{benefitResult.businessPhone}}</a>
            <span class="phone-desktop" *ngIf="!isMobile && benefitResult.businessPhone">{{benefitResult.businessPhone}}</span>
            <a aria-label="נפתח באתר חיצוני" u1-link (click)="navigateToBusiness()" title="" class="link bu-link" *ngIf="benefitResult.businessWebsite">לאתר בית העסק</a>
        </div>
        <div class="important-to-know" *ngIf="!data">חשוב לדעת!</div>
        <span class="terms" *ngIf="importantInformation" [innerHtml]="importantInformation"></span>
        <div class="button-wrapper" *ngIf="data && isMobile">
            <a title="" class="brand-button aqua-button" (click)="closePopup()"><span>הבנתי, תודה</span></a>
        </div>
    </div>
</div>

